import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SubAcctComponent } from '../sub-acct/sub-acct.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.css']
})
export class AccountListComponent implements OnInit {

  public menu_item_id = '93';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['acct_number', 'sub_acct_name', 'sub_acct_name_en', 'parent_acct', 'acct_level',
    'balance', 'edit', 'del'];
  displayedColumns2 = ['acct_number', 'sub_acct_name', 'sub_acct_name_en', 'parent_acct', 'acct_level', 
    'balance'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<SubAcctComponent>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'sub_acct', 'parent_acct': '', 'sub_acct_name': '', 'acct_number': '', 'title': 'قائمة الموردين'
  };

  // typeList = [];
  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    // translate.get('Supplier_List').subscribe((res: string) => {
    //   this.Supplier_List = res;
    // });
    // this.model['title'] = this.Supplier_List;

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    // let parent_acct = "0";
    // let obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: false, only_leaf: false };
    // this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.type_list = data.data['list'];
    //     this.type_list.unshift({ 'acct_number': '', 'sub_acct_name': 'الكل', 'sub_acct_name_en': 'All' })
    //     // console.log(this.type_list);
    //   });

    // let query = this.queryList.acct_config;
    // let obj = { cmd: 'getList', query: query };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.typeList = data.data['list'];
    //   });
  }

  newSubAcct() {
    this.addDialogRef = this.dialog.open(SubAcctComponent, {
      hasBackdrop: false
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + (document.getElementById('title') as HTMLFormElement).getValue() + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('account_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  search() {

    let obj = { cmd: 'getSubAcctList' };

    if (this.model['acct_number'] != '')
      obj['acct_number'] = this.model['acct_number'];

    if (this.model['sub_acct_name'] != '')
      obj['sub_acct_name'] = this.model['sub_acct_name'];

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.status['msg'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

    // let condition = "";

    // if (this.model['parent_acct'] != '')
    //   condition += " AND `parent_acct` = '" + this.model['parent_acct'] + "'";

    // if (this.model['acct_number'] != '')
    //   condition += " AND `acct_number` LIKE '%" + this.model['acct_number'] + "%'";

    // if (this.model['sub_acct_name'] != '')
    //   condition += " AND (`sub_acct_name` LIKE '%" + this.model['sub_acct_name'] +
    //     "%' OR `sub_acct_name_en` LIKE '%" + this.model['sub_acct_name'] + "%')";

    // let query = "SELECT *, (CASE WHEN `parent_acct` = '0' THEN '' ELSE (SELECT CONCAT(`acct_number`, ' - ', `sub_acct_name`) FROM" +
    //   " `sub_acct` AS `parent_table` WHERE `sub_acct`.`parent_acct` = `parent_table`.`acct_number` AND `parent_table`.`status` = '1') END) AS 'parent_name', " + 
    //   "(CASE WHEN `parent_acct` = '0' THEN '' ELSE (SELECT CONCAT(`acct_number`, ' - ', `sub_acct_name_en`) FROM" +
    //   " `sub_acct` AS `parent_table` WHERE `sub_acct`.`parent_acct` = `parent_table`.`acct_number` AND `parent_table`.`status` = '1') END) AS 'parent_name_en'" + 
    //   " FROM `sub_acct` WHERE `status` = '1'" + condition;
    // let obj = { cmd: 'getList', query: query };
    // // console.log(query);

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.dp = data.data['list'];
    //     this.dataSource = new MatTableDataSource(this.dp);
    //     this.dataSource.sort = this.sort;
    //   });
  }

  editSubAcct(row) {
    this.addDialogRef = this.dialog.open(SubAcctComponent, {
      hasBackdrop: false,
      data: { 'sub_acct_id': row.sub_acct_id }
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delSubAcct(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'sub_acct_id': row.sub_acct_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();

            // if (row.main_acct_no == this.applicationConstants.main_acct_config['customer'])
            //   this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
